import { log } from 'utils/console';
import { getInstance as getBootstrap } from 'utils/bootstrap';

import Iframe from './iframe';

import './styles.styl';

const NAME = 'tuning-fork-parent';

export default function initialize() {
    const bootstrap = getBootstrap();
    const isEnabled = bootstrap.get('renderTuningForkIframe');

    log(NAME, 'initialize', isEnabled);

    if (isEnabled) {
        const data = bootstrap.get('tuningFork');
        Iframe.create(data.splashDomain, {
            iframeAttrs: data.iframeAttrs,
        });
    }
}
